
import { defineComponent, PropType } from "vue";
import { WizardSessionListItem } from "@/flow/services/wizard.service";

export default defineComponent({
  name: "WizardHistory",
  props: {
    // `preview` for auto-debug sessions is redacted by the caller
    // (WizardDrawer.vue) before it ever reaches this presentation-only
    // component — see isAutoDebugSeedText in wizard.service.ts.
    sessions: {
      type: Array as PropType<WizardSessionListItem[]>,
      default: () => [],
    },
    loading: { type: Boolean, default: false },
    activeSessionId: { type: String, default: null },
  },
  emits: ["new-chat", "select-session"],
  setup() {
    function formatTimestamp(timestamp?: string): string {
      if (!timestamp) {
        return "Just now";
      }

      const date = new Date(timestamp);
      if (Number.isNaN(date.getTime())) {
        return "Just now";
      }

      return new Intl.DateTimeFormat(undefined, {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      }).format(date);
    }

    function formatStatus(status: string): string {
      switch (status) {
        case "waiting_for_user":
          return "Needs input";
        case "processing":
          return "Active";
        case "cancelled":
          return "Cancelled";
        case "completed":
          return "Completed";
        case "error":
          return "Error";
        default:
          return status;
      }
    }

    return {
      formatStatus,
      formatTimestamp,
    };
  },
});
